module.exports = __webpack_public_path__ + "static/media/btc12.2fdaa8a6.svg";